<template>
    <div class="saving-process">
        <h5>Saving your automation changes</h5>
        <div class="prog-line">
            <div class="prog-line-inner" v-bind:style="{width: progressNumber +'%'}"></div>
        </div>
        <span class="btm-info">Please wait while the process finishes...</span>
        <p>P.S. You can close this dialog and let the process complete in the background</p>
    </div>
</template>

<script>

export default {
    data() {
        return {
            progressNumber: 0
        }
    },
    methods: {
        progressIncrement() {
            let progressIncrementInterval = setInterval(() => {
                if (this.progressNumber !== 100) {
                    this.progressNumber += 1;
                } else {
                    clearInterval(progressIncrementInterval);
                    console.log('interval stop');
                    //this.$store.commit("createNewAutomation")
                    this.$store.commit("closeAutomationPopup")
                }
            }, 10);
        }
    },
    computed: {

    },
    mounted() {
        this.progressIncrement();
    }
}
</script>